import React, { useState, Component } from 'react';
import ToggleSwitch from '../Atoms/ToggleSwitch';
import Heading from '../Atoms/Heading.js';
import Toast from '../Atoms/Toast';
import SalamiWall from '../Atoms/SalamiWall';
import { Link } from 'react-router-dom'


function TopBar() {
  
    const [toggle, setToggle] = useState(true);


    const onToggleChange = (checked) => {
      setToggle(checked);
    }
  
  

    return <div className="bb flex max-w-100">
        <Link to="/" className="br flex-basis-75 items-center align-content-center flex pl-m h3 phone-h-7" >
          <Heading cx="letter-spacing-medium" content="Sonja Lillebæk Christensen" headingLevel="h1"/>
          {/* <Heading cx="letter-spacing-medium cursive" content="Sonja Lillebæk Christensen" headingLevel="h1"/> */}
        </Link>
        <div className=" h-3 phone-h-7 flex flex-basis-4th items-center no-shrink ">
          <ToggleSwitch id="SalamiToggle" checked={ toggle } onChange={ onToggleChange } />
        </div>

        {/* <Toast checked={toggle}/> */}
        {toggle ? <SalamiWall /> : ''}
         
      </div>
    
  
}

export default TopBar;